import { FC } from 'react';
import { Navigate, Route as ReactRouterRoute, Routes } from 'react-router-dom';

import {
  AdvancedSearchPage,
  CallNumbersPage,
  ConditionalRoute,
  CourseReserveDetailsPage,
  CourseReservesPage,
  HoldsAndCheckoutsPage,
  InstanceDetailsPage,
  NavigationLayout,
  NotFoundPage,
  PreferencesPage,
  ProjectsDetailsPage,
  ProjectsPage,
  RecentActivityPage,
  SavedPage,
  SearchResultsPage,
} from '@app/components';
import { useHoldsAndCheckoutsPageConfig } from '@app/hooks';
import { Feature, Route } from '@app/constants';

export const getPathWithDescendantRoutes = (route: Route): string =>
  `${route}/*`;

export const MainPage: FC = () => {
  const { holdsAndCheckoutsRoute } = useHoldsAndCheckoutsPageConfig();

  return (
    <Routes>
      <ReactRouterRoute element={<NavigationLayout />}>
        <ReactRouterRoute
          path={getPathWithDescendantRoutes(holdsAndCheckoutsRoute)}
          element={
            <ConditionalRoute
              flagToMatch={{
                name: Feature.holdsAndCheckouts,
                isActiveIfNotFound: true,
              }}
            >
              <HoldsAndCheckoutsPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={Route.instanceDetails}
          element={<InstanceDetailsPage />}
        />
        <ReactRouterRoute path={Route.search} element={<SearchResultsPage />} />
        <ReactRouterRoute
          path={Route.advancedSearch}
          element={<AdvancedSearchPage />}
        />
        <ReactRouterRoute
          path={Route.courseReserveDetails}
          element={
            <ConditionalRoute flagToMatch={{ name: Feature.courseReserves }}>
              <CourseReserveDetailsPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={Route.courseReserves}
          element={
            <ConditionalRoute flagToMatch={{ name: Feature.courseReserves }}>
              <CourseReservesPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={Route.callNumbers}
          element={
            <ConditionalRoute flagToMatch={{ name: Feature.callNumbers }}>
              <CallNumbersPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={Route.preferences}
          element={
            <ConditionalRoute
              flagToMatch={{ name: Feature.consortiaLoginFlow }}
              shouldRenderOnFalse
            >
              <PreferencesPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={Route.projects}
          element={
            <ConditionalRoute flagToMatch={{ name: Feature.LCDashboard }}>
              <ProjectsPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={getPathWithDescendantRoutes(Route.projectsDetails)}
          element={
            <ConditionalRoute flagToMatch={{ name: Feature.LCDashboard }}>
              <ProjectsDetailsPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={getPathWithDescendantRoutes(Route.recentActivity)}
          element={
            <ConditionalRoute flagToMatch={{ name: Feature.LCDashboard }}>
              <RecentActivityPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute
          path={getPathWithDescendantRoutes(Route.saved)}
          element={
            <ConditionalRoute flagToMatch={{ name: Feature.LCDashboard }}>
              <SavedPage />
            </ConditionalRoute>
          }
        />
        <ReactRouterRoute path={Route.notFound} element={<NotFoundPage />} />
        <ReactRouterRoute
          path={Route.root}
          element={<Navigate replace to={Route.search} />}
        />
        <ReactRouterRoute
          path="*"
          element={<Navigate replace to={Route.notFound} />}
        />
      </ReactRouterRoute>
    </Routes>
  );
};
